import ilcsLogo from 'assets/images/districts/ilcs-logo.svg'

// IL state senate district badges, indexed by district number. The bundled
// `_fallback.svg` (Illinois flag) is used for any IL state-senate district
// the customer hasn't supplied a specific badge for.
import ilFlagFallback from 'assets/images/districts/state-senate/_fallback.svg'
import sen17 from 'assets/images/districts/state-senate/17.jpg'
import sen24 from 'assets/images/districts/state-senate/24.webp'
import sen26 from 'assets/images/districts/state-senate/26.png'
import sen32 from 'assets/images/districts/state-senate/32.png'
import sen33 from 'assets/images/districts/state-senate/33.png'
import sen35 from 'assets/images/districts/state-senate/35.png'
import sen37 from 'assets/images/districts/state-senate/37.png'
import sen41 from 'assets/images/districts/state-senate/41.png'
import sen44 from 'assets/images/districts/state-senate/44.png'
import sen45 from 'assets/images/districts/state-senate/45.webp'
import sen47 from 'assets/images/districts/state-senate/47.png'
import sen50 from 'assets/images/districts/state-senate/50.png'
import sen51 from 'assets/images/districts/state-senate/51.png'
import sen53 from 'assets/images/districts/state-senate/53.png'
import sen54 from 'assets/images/districts/state-senate/54.png'
import sen55 from 'assets/images/districts/state-senate/55.png'
import sen56 from 'assets/images/districts/state-senate/56.png'
import sen58 from 'assets/images/districts/state-senate/58.png'
import sen59 from 'assets/images/districts/state-senate/59.png'

interface RegisteredLogos {
  mainLogo?: string
  topLogo?: string
}

// Bundled-asset logos for pilot tenants. Keyed by tenant id (SenatorInstance `id`).
// Used when the senator-instance row has a tenant id match — overrides the
// per-district lookup below.
export const TENANT_LOGO_REGISTRY: Record<string, RegisteredLogos> = {
  'il-state-senate-17': {
    mainLogo: sen17,
    topLogo: ilcsLogo,
  },
}

// IL state-senate district badges, indexed by the integer district number.
// Resolver tries here first (exact match by district), then falls back to
// the IL flag for any IL district without a specific image.
export const STATE_SENATE_DISTRICT_LOGOS: Record<number, string> = {
  17: sen17,
  24: sen24,
  26: sen26,
  32: sen32,
  33: sen33,
  35: sen35,
  37: sen37,
  41: sen41,
  44: sen44,
  45: sen45,
  47: sen47,
  50: sen50,
  51: sen51,
  53: sen53,
  54: sen54,
  55: sen55,
  56: sen56,
  58: sen58,
  59: sen59,
}

export const STATE_SENATE_FALLBACK_LOGO = ilFlagFallback

// Resolve a logo for any IL state senate district: prefer a district-specific
// badge if one is bundled, otherwise return the Illinois-flag fallback.
export const resolveStateSenateLogo = (districtNumber: number): string =>
  STATE_SENATE_DISTRICT_LOGOS[districtNumber] || STATE_SENATE_FALLBACK_LOGO
